<template>
    <component
        v-if="componentName"
        :is="componentName"
        :message="message"
    >
    </component>
</template>

<script>
import store from "../../store";
import PlayerAction from "./SystemMessages/PlayerAction";
import SystemMessage from "./SystemMessages/SystemMessage";
import SystemNotification from "./SystemMessages/SystemNotification";
import ResultsTable from "./SystemMessages/ResultsTable";
import CommonMessage from "./SystemMessages/CommonMessage";

export default {
    props: {
        message: {
            type: Object,
            required: true
        }
    },

    components: {
        PlayerAction,
        SystemMessage,
        SystemNotification,
        ResultsTable,
        CommonMessage,
    },

    data() {
        return {
            componentName: null,
        }
    },

    mounted() {
        this.getComponentName(this.message);
    },

    computed: {
        players: () => store.getters.getPlayers,
    },

    methods: {
        /**
         * Компонент для сообщения
         * @param message
         */
        getComponentName(message)
        {
            if (message.data.type === this.$parent.MESSAGE_TYPE_PLAYER_ACTION) {
                this.componentName = 'PlayerAction';
                return;
            }

            if (message.data.type === this.$parent.MESSAGE_TYPE_SYSTEM_MESSAGE) {
                this.componentName = 'SystemMessage';
                return;
            }

            if (message.data.type === this.$parent.MESSAGE_TYPE_SYSTEM_NOTIFICATION) {
                this.componentName = 'SystemNotification';
                return;
            }

            if (message.data.type === this.$parent.MESSAGE_TYPE_RESULT) {
                this.componentName = 'ResultsTable';
                return;
            }

            if (message.data.type === this.$parent.MESSAGE_TYPE_COMMON_MESSAGE) {
                this.componentName = 'CommonMessage';
                return;
            }
        },
    }

}
</script>

<style scoped lang="scss">

</style>
